<template>
    <div class="home">
        <v-layout row wrap>
             <v-flex xs12 md12 lg12>
                 <Commercials/>
            </v-flex>
           <v-flex xs12 md12 lg12>
                <PriceTable/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import PriceTable from '@/components/PriceTable'
    import Commercials from '@/components/Commercials'
    export default {
        name: "Home",
        data(){
            return {
            }
        },
        components: {
            PriceTable,
            Commercials,
        },
    }
</script>

<style scoped>

</style>